import React, { useState, useEffect, useMemo, useContext } from "react";
import "ol/ol.css"; //스타일
import { Feature, Map as OlMap, View } from "ol";
import { fromLonLat, get as getProjection } from "ol/proj"; //위경도
import { Vector, XYZ } from "ol/source";

import VectorLayer from "ol/layer/Vector";
import { Point } from "ol/geom";
import LayerSwitcher from "ol-layerswitcher";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import LayerGroup from "ol/layer/Group";
import { Tile } from "ol/layer";
import { Style, Icon, Fill, Stroke, Circle } from "ol/style";
import crossSvg from "./cross.svg";
import pinSvg from "./pin.svg";

import DeclareContext from "../../context/users/DeclareContext";
import { bems_inc_Url } from "../UserPage/ascon/AsconMap";

const midNightMap = new Tile({
  //배경지도 레이어
  title: "다크지도",
  displayInLayerSwitcher: false,
  visible: true,
  source: new XYZ({
    url: `${bems_inc_Url}/tiles/midnight/{z}/{y}/{x}.png`,
  }),
});

const baseMap = new Tile({
  //배경지도 레이어
  title: "배경지도",
  displayInLayerSwitcher: false,
  visible: true,
  source: new XYZ({
    url: `${bems_inc_Url}/tiles/base/{z}/{y}/{x}.png`,
  }),
});

const aerialMap = new Tile({
  //배경지도 레이어
  title: "항공지도",
  visible: false,
  source: new XYZ({
    url: `${bems_inc_Url}/tiles/aerial/{z}/{y}/{x}.jpeg`,
  }),
});

const hybridMap = new Tile({
  //배경지도 레이어
  title: "하이브리드",
  visible: true,
  source: new XYZ({
    url: `${bems_inc_Url}/tiles/Hybrid/{z}/{y}/{x}.png`,
  }),
});

const aerialGroupMap = new LayerGroup({
  // 항공지도 그룹맵
  title: "항공지도",
  baseLayer: true,
  openInLayerSwitcher: true,
  visible: false,
  layers: [aerialMap, hybridMap],
});

const darkGroupMap = new LayerGroup({
  // 배경지도 그룹맵
  title: "배경지도(다크)",
  baseLayer: true,
  openInLayerSwitcher: true,
  visible: false,
  layers: [midNightMap, hybridMap],
});

// LayerSwitcher 컨트롤 추가
const layerSwitcher = new LayerSwitcher({
  tipLabel: "레이어 전환",
  mouseover: true,
  collapsed: true,
  className: "layer-switcher", // 사용자 정의 클래스 이름
});

const popupElement = document.createElement("div");
popupElement.style.display = "none";
popupElement.id = "popup";
document.body.appendChild(popupElement);

function MoveEndMap(props, { enableInteractions }) {
  const { positionXY, searchType, posToAddr } = useContext(DeclareContext);
  const [mapObject, setMapObject] = useState(null);

  const poiLayer = useMemo(() => {
    const markerStyle = new Style({
      fill: new Fill({
        color: "rgba(255, 255, 255, 0.2)",
      }),
      stroke: new Stroke({
        color: "#3B11B2",
        width: 2,
      }),
      image: new Circle({
        radius: 12,
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.4)",
        }),
        stroke: new Stroke({ color: "#3B11B2", width: 2 }),
      }),
    });
    let vectorLayer = new VectorLayer({
      source: new Vector({ wrapX: false }),
      style: markerStyle,
    });
    return vectorLayer;
  }, []);
  const crossMarkerLayer = useMemo(() => {
    let markerStyle = new Style({
      image: new Icon({
        //마커 이미지
        opacity: 1, //투명도 1=100%
        scale: 2, //크기 1=100%
        src: crossSvg,
      }),
      //html의 css, z-index 기능이다.
      zindex: 10,
    });

    let markerSource = new Vector();
    let markerLayer = new VectorLayer({
      source: markerSource, //마커 feacture들
      style: markerStyle, //마커 스타일
    });
    return markerLayer;
  }, []);

  const pinMarkerLayer = useMemo(() => {
    let markerStyle = new Style({
      image: new Icon({
        //마커 이미지
        opacity: 1, //투명도 1=100%
        scale: 0.1, //크기 1=100%
        src: pinSvg,
      }),
      //html의 css, z-index 기능이다.
      zindex: 10,
    });

    let markerSource = new Vector();
    let markerLayer = new VectorLayer({
      source: markerSource, //마커 feacture들
      style: markerStyle, //마커 스타일
    });
    return markerLayer;
  }, []);

  useEffect(() => {
    if (mapObject === null) {
      // 지도 중복 생성 막음
      var map = new OlMap({
        // controls: defaultControls({ zoom: false, rotate: false }).extend([]),
        target: "mapc",
        view: new View({
          projection: getProjection("EPSG:3857"),
          zoom: 15,
          center: fromLonLat([126.654839, 37.453079]),
          extent: [13982033, 4420002, 14120003, 4575085],
        }),
        // interactions: enableInteractions ? undefined : [],
      });
      // map.addLayer(darkGroupMap);
      // map.addLayer(aerialGroupMap);
      map.addLayer(aerialMap);
      map.addLayer(baseMap);
      map.addLayer(poiLayer);
      map.addLayer(crossMarkerLayer);
      // map.addLayer(pinMarkerLayer);
      map.addControl(layerSwitcher);

      setMapObject({ map });

      const handleMoveEnd = (evt) => {
        const center = map.getView().getCenter();
        if (typeof props.func === "function") {
          props.func(center);
        }

        let markerFeature = new Feature({
          geometry: new Point(center), // 중심 좌표를 기반으로 마커 생성
        });
        // pinMarkerLayer.getSource().clear();
        crossMarkerLayer.getSource().clear();
        crossMarkerLayer.getSource().addFeature(markerFeature);

        posToAddr(center);
      };

      map.on("moveend", handleMoveEnd);
      return () => {
        map.un("moveend", handleMoveEnd);
        map.setTarget(undefined);
      };
    }
  }, [enableInteractions]);

  useEffect(() => {
    if (mapObject && positionXY) {
      if (!Array.isArray(positionXY) || positionXY.length !== 2) {
        console.error("Invalid positionXY:", positionXY);
        return;
      }

      const transformedCoords = positionXY;

      crossMarkerLayer.getSource().clear();
      // pinMarkerLayer.getSource().clear();

      let markerFeature = new Feature({
        geometry: new Point(transformedCoords),
      });

      if (searchType === 2) {
        // 지도에서 검색
        crossMarkerLayer.getSource().addFeature(markerFeature);
        mapObject.map.getView().setCenter(transformedCoords);
      } else {
        // 주소로 검색
        // pinMarkerLayer.getSource().addFeature(markerFeature);
      }

      // Set map view center
    }
  }, [positionXY, mapObject, searchType]);

  return (
    <div>
      <div className="nowDataMap">
        <div id="mapc" value={mapObject} style={{ height: "400px" }}></div>
      </div>
    </div>
  );
}
export default MoveEndMap;
